<template>
  <div class="layout__header">
    <div
      class="top"
      :class="{ hide_menu: isShowMenu, hide_menu_hover: showMenuHide }"
      @mouseenter="changeShowMenuHide"
    >
      <div class="left">
        <AppLogo :collapsed="collapsed"></AppLogo>
      </div>
      <div class="center">
        <BaseMenu :collapsed="collapsed"></BaseMenu>
      </div>
      <div class="right">
        <LocaleSelect></LocaleSelect>
        <HeaderAction :collapsed="collapsed"></HeaderAction>
      </div>
    </div>
    <div class="yzs-tabs-container bottom">
      <LayoutTabs></LayoutTabs>
    </div>
  </div>
</template>
<script lang="ts" setup>
import AppLogo from "./AppLogo.vue";
import BaseMenu from "../menu/menu.vue";
import { computed, ref } from "vue";
import HeaderAction from "./Action.vue";
import LayoutTabs from "../tabs/tabs.vue";
import LocaleSelect from "./LocaleSelect.vue";
import { useStore } from "vuex";

const collapsed = ref<boolean>(false);
const store = useStore();
const isShowMenu = computed(() => {
  return store.state.user.isShowMenu;
});
const showMenuHide = computed(() => {
  return store.state.user.showMenuHide;
});
function handleHideMenu() {
  if (!showMenuHide.value) return;
  setTimeout(() => {
    store.state.user.showMenuHide = false;
  }, 300);
}
function changeShowMenuHide() {
  store.state.user.showMenuHide = true;
}

defineExpose({
  handleHideMenu,
});
</script>
<style lang="scss" scoped>
.layout__header {
  position: fixed;
  // background-color: #fff;
  display: flex;
  z-index: 1;
  width: 100%;
  flex-direction: column;

  .top {
    position: relative;
    display: flex;
    width: 100%;
    padding: 0px 15px;
    align-items: center;
    background-color: #464d57;
    height: 40px;

    .left {
      position: relative;
      width: 80px;
      margin-right: 10px;
    }

    .center {
      position: relative;
      flex-grow: 1;
      overflow: hidden;
    }

    .right {
      position: relative;
      // width: 230px;
      display: flex;
      justify-content: end;
      align-items: center;
    }
  }
  .bottom {
    position: relative;
    width: 100%;
    // margin-top: 3px;
    padding-top: 10px;
  }
}

.layout__header .hide_menu {
  position: relative;
  margin-top: -35px;
  z-index: 3;
  opacity: 0;
  transition: margin-top 0.3s ease, opacity 0.3s ease; /* 平滑过渡效果 */
}

.layout__header .hide_menu_hover {
  position: relative;
  // top: 0; /* 鼠标悬停时，top 变为 0 */
  margin-top: 0px;
  opacity: 1; /* 鼠标悬停时，完全不透明 */
}
</style>
